import type { SpreadRxNutrient } from "../../lib/spreadRx";
import {
  NUTRIENT_LABEL,
  NUTRIENT_WORD,
} from "../spread-rx-table/SpreadRxTable";

const ORDER: SpreadRxNutrient[] = ["lime", "p2o5", "k2o"];

export function SpreadNutrientChooser({
  fieldCount,
  available,
  picked,
  onPicked,
  onContinue,
}: {
  fieldCount: number;
  available: SpreadRxNutrient[];
  picked: SpreadRxNutrient[];
  onPicked: (next: SpreadRxNutrient[]) => void;
  onContinue: () => void;
}) {
  const fieldsWord = fieldCount === 1 ? "" : "s";
  return (
    <div className="mx-auto max-w-md">
      <h1 className="mb-1 text-center text-lg font-bold">
        Which nutrients does this product carry?
      </h1>
      {/*
        Says WHY the list is what it is, so an absent nutrient reads as a fact about the fields
        rather than a missing feature.
      */}
      <p className="mb-3 text-center text-[11px] text-muted">
        Only nutrients every selected field has an Rx for — a blend has to mean
        the same thing on all of them.
      </p>
      {available.length === 0 ? (
        <p className="text-center text-[12px] text-muted">
          No nutrient has a saved Rx on all {fieldCount} selected field
          {fieldsWord}. Build the missing ones under{" "}
          <span className="font-medium text-fg">Build Rx</span>, or select fewer
          fields.
        </p>
      ) : (
        <div className="flex flex-col gap-1.5">
          {available.map((n) => (
            <label
              key={n}
              className="flex cursor-pointer items-center gap-2 rounded border border-line px-2 py-1.5 text-[12px] hover:bg-hover"
            >
              <input
                type="checkbox"
                aria-label={NUTRIENT_LABEL[n]}
                checked={picked.includes(n)}
                onChange={(e) =>
                  onPicked(
                    e.target.checked
                      ? ORDER.filter((x) => picked.includes(x) || x === n)
                      : picked.filter((x) => x !== n),
                  )
                }
              />
              <span className="font-medium">{NUTRIENT_LABEL[n]}</span>
              <span className="text-[10px] text-faint">
                {NUTRIENT_WORD[n]} Rx on all {fieldCount} field
                {fieldsWord}
              </span>
            </label>
          ))}
          <button
            disabled={picked.length === 0}
            onClick={onContinue}
            className="mt-2 self-end rounded bg-accent px-3 py-1.5 text-[12px] font-medium text-canvas hover:bg-accent-hover disabled:opacity-40"
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
}
